/* Video wall rail: arrow scrolling, plus play/pause tied to visibility.
 *
 * Autoplaying every clip at once burns bandwidth and battery for videos nobody
 * is looking at, and iOS refuses to run more than a couple concurrently anyway.
 * IntersectionObserver plays only what is on screen and pauses the rest.
 */
(function () {
  function initRail(rail) {
    if (rail.dataset.vvwInit) return;
    rail.dataset.vvwInit = '1';

    var root = rail.closest('.vvw');
    var prev = root && root.querySelector('[data-vvw-prev]');
    var next = root && root.querySelector('[data-vvw-next]');

    function page() {
      var card = rail.querySelector('.vvw__card');
      // Scroll by a whole card plus its gap so a card never ends up half cut off.
      return card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    }

    function syncArrows() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -page(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: page(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();

    var videos = rail.querySelectorAll('video');
    if (!videos.length) return;

    // Muted + playsinline are what make inline autoplay legal on iOS. The Liquid
    // sets them, but a re-render through the Section Rendering API can drop the
    // attributes, so re-assert them on the element itself.
    videos.forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      v.loop = true;
    });

    if (!('IntersectionObserver' in window)) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          // Autoplay rejection is normal (low power mode, iOS policy). The poster
          // stays up; do not let the unhandled rejection reach the console.
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { root: rail, threshold: 0.5 });

    videos.forEach(function (v) { io.observe(v); });
  }

  function init() {
    document.querySelectorAll('[data-vvw-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
